import { useCallback, useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg, fmtDateTime } from "../../lib/api";

const TYPE_STYLE = {
  crm_form: ["New Form Lead", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  crm_fb: ["Facebook", "bg-blue-50 text-blue-700 border-blue-200"],
  crm: ["CRM", "bg-violet-50 text-violet-700 border-violet-200"],
};

export default function CrmNotifications() {
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    api.get("/store-admin/crm/notifications").then((r) => setItems(r.data.notifications)).catch((e) => toast.error(errMsg(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const markAll = async () => {
    try { await api.post("/notifications/read-all"); toast.success("All marked as read"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-4" data-testid="crm-notifications">
      <div className="flex items-center justify-between">
        <h2 className="font-display font-bold text-lg flex items-center gap-2"><Bell className="h-5 w-5" /> CRM Notifications</h2>
        <button onClick={markAll} data-testid="crm-notif-readall" className="h-9 px-4 rounded-xl border border-border text-xs font-extrabold flex items-center gap-1.5 hover:bg-muted"><CheckCheck className="h-3.5 w-3.5" /> Mark all read</button>
      </div>
      {items === null ? <div className="h-28 flex items-center justify-center"><div className="h-7 w-7 rounded-full border-2 border-border border-t-foreground animate-spin" /></div>
        : items.length === 0 ? <div className="rounded-2xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground" data-testid="crm-notif-empty">No CRM notifications yet.</div>
        : (
          <div className="space-y-2">
            {items.map((n) => {
              const [lbl, cls] = TYPE_STYLE[n.type] || TYPE_STYLE.crm;
              return (
                <div key={n.id} className={`rounded-2xl border border-border bg-background p-4 flex items-start gap-3 ${n.read ? "opacity-60" : ""}`} data-testid={`crm-notif-${n.id}`}>
                  <span className={`shrink-0 px-2 py-1 rounded-full text-[9px] font-extrabold uppercase tracking-wide border ${cls}`}>{lbl}</span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-bold truncate">{n.title}</p>
                    <p className="text-xs text-muted-foreground break-words">{n.body}</p>
                    <p className="text-[10px] text-muted-foreground mt-1">{fmtDateTime(n.created_at)}</p>
                  </div>
                  {!n.read && <span className="h-2 w-2 rounded-full bg-emerald-500 mt-1.5 shrink-0" />}
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}
